export const DOMAIN = 'https://tillsammans.bengtdahlgren.se'